import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import { ROLES_FOR_APP, isHavePermissionRole } from "helpers/role";
import { useRole } from "components/Hooks/UserHooks";
import BreadCrumb from "components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";


const Dashboard = () => {

  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [rightColumn, setRightColumn] = useState(true);

  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  useEffect(() => {
    document.title = `${t('Dashboard')} - ${t('Dashboard')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Dashboard')} pageTitle={t('Home')} />
          <Row>
            <Col>
              <div className="h-100">
                <Row>
                  {isHavePermissionRole(ROLES_FOR_APP.DASHBOARD_VIEW, userPermissions) && <Widget />}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
